export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Kopiert!",
    copy: "Kopieren",
    edit: "Bearbeiten",
    remove: "Entfernen",
    addLink: "OTA-Link",
    modalEyebrow: "Link des Inserats auf der OTA",
    modalEyebrowUnit: "Link dieser Einheit bei der OTA",
    editTitle: "Link bearbeiten",
    addTitle: "OTA-Link hinzufügen",
    modalHint: "Fügen Sie die öffentliche URL <b>dieses Inserats</b> auf der OTA ein. So können Sie sie schnell kopieren und öffnen.",
    urlLabel: "URL des Inserats",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Link speichern",
    saveError: "Der Link konnte nicht gespeichert werden. Prüfen Sie die URL.",
    fromListing: "vom Objekt",
    inheritedNote: "Das ist der Link des Objekts. Solange diese Einheit keinen eigenen hat, wird dieser gesendet.",
    override: "Eigenen festlegen",
    modalHintUnit: "Füge die öffentliche URL <b>dieser Einheit</b> bei der OTA ein. Wenn du sie setzt, wird diese gesendet; bleibt sie leer, wird die des Objekts gesendet.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Gästereise simulieren",
    badge: "Test",
    intro: "Spielen Sie den gesamten Ablauf, von der Buchung bis zur Bewertung, in einem WhatsApp-Chat durch. Geben Sie einen Namen und eine Nummer ein und drücken Sie <strong>Play</strong>. Wenn Sie «An Handy senden» aktivieren, wird jede Nachricht wirklich an die Nummer geschickt, damit Sie sie ausprobieren und mit dem KI-Agenten chatten können.",
    guestNameLabel: "Name des Gastes",
    guestNamePlaceholder: "z. B. Laura García",
    phoneLabel: "WhatsApp-Nummer (zum Testen)",
    phoneHint: "Internationales Format, z. B. +34 600123456",
    toggleTitle: "Auch an Handy senden",
    toggleDesc: "Jeder Schritt wird wirklich an die Nummer oben geschickt",
    warn: "Senden Sie zuerst «Hallo» von Ihrem Handy an die Nummer, um das 24-Stunden-Fenster von WhatsApp zu öffnen; so erhalten Sie die Nachrichten sofort.",
    reset: "Neu starten",
    prev: "Zurück",
    pause: "Pause",
    play: "Play",
    continue: "Weiter",
    next: "Weiter",
    stepProgress: "Schritt {current} von {total}",
    guestFallback: "Gast",
    propertyFallback: "Ihre Unterkunft",
    testNumberFallback: "Testnummer",
    dayLabel: "Gästereise",
    loadingMsgs: "Ihre Nachrichten werden geladen…",
    pressPlay: "Drücken Sie <strong>Play</strong>, um die Reise zu starten ▶",
    hintSending: "Live-Versand aktiv · jeder Schritt erreicht {phone}",
    hintSimulated: "Simulierte Ansicht · aktivieren Sie «An Handy senden», um auf einem echten Gerät zu testen",
    toastInvalidPhone: "Geben Sie eine gültige WhatsApp-Nummer für den Versand ans Handy ein.",
    toastSendFailed: "Senden nicht möglich.",
    toastSendMobileFailed: "Senden ans Handy nicht möglich.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Hallo *{{nombre_huesped}}* 👋\n\nIhre Buchung in *{{nombre_alojamiento}}* ist bestätigt ✅\n\nBuchungscode: *6233Q1VC5*\nDaten: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nÜber dieses WhatsApp können Sie Ihren Link für den Online-Check-in anfordern und die Anreisehinweise erhalten.",
    msgCheckinPrompt: "*Hallo* 👋 Ich bin der virtuelle Assistent von *{{nombre_alojamiento}}*.\n\nDrücken Sie *Ok*, um mit Ihrem Check-in fortzufahren.",
    msgChooseLanguage: "Wählen Sie Ihre Sprache · Choose your language",
    msgCheckinLink: "*Danke* 👋 Hier ist Ihr Link für den Check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Willkommen in *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nVielen Dank für Ihre Registrierung. Hier finden Sie alle Informationen zu Ihrem Aufenthalt.",
    msgAccess: "🔒🔑 *Zugangscode · {{nombre_alojamiento}}*\n\nIhr Code lautet: *58117*\n\nWährend Ihres gesamten Aufenthalts gültig.",
    msgArrival: "🏡 *Anreisehinweise*\n\nGehen Sie bei Ihrer Ankunft zum Haupteingang und geben Sie Ihren Code am Schloss ein. 🔑\n\nGenießen Sie Ihren Aufenthalt! ✨",
    msgGuestCheckout: "Hallo, wann ist der Check-out?",
    msgCheckoutReply: "Hallo! Der Check-out ist bis *12:00* Uhr 🕚 Wenn Sie später abreisen möchten, prüfe ich gern einen späten Check-out für Sie 😊",
    msgCheckout: "Hallo *{{nombre_huesped}}* 👋\n\nNur zur Erinnerung: *Ihr Aufenthalt endet morgen* in *{{nombre_alojamiento}}*.\n\n🕚 Der späteste Check-out ist um *{{hora_salida}}*.\n\nVielen Dank für Ihren Besuch und gute Reise! 😊",
    msgReview: "⭐ Wie war Ihr Aufenthalt in *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nWir freuen uns über Ihre Rückmeldung. Hinterlassen Sie hier Ihre Bewertung 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Gästereise",
    subtitle: "Von der Buchung bis zur Abreise. Fahren Sie über ein Ereignis, um die Nachricht zu sehen.",
    disabled: "Deaktiviert",
    clickToConfigure: "Zum Einrichten klicken",
    nameFallback: "Ihre Unterkunft",
    // Node labels
    labelLead: "Buchung / Lead",
    labelConfirm: "Bestätigung",
    labelCheckinLink: "Check-in-Link",
    labelWelcome: "Willkommen",
    labelAccess: "Zugang / Schloss",
    labelArrival: "Anreisehinweise",
    labelCheckout: "Abreisenachricht",
    labelReview: "Bewertung",
    // Timing of each node
    whenLead: "Bei Buchung oder Nachricht",
    whenConfirm: "Buchung bestätigt",
    whenCheckinLink: "Vor der Anreise",
    whenWelcome: "Nach der Registrierung",
    whenAccess: "Anreisetag",
    whenArrival: "Anreisetag",
    whenCheckout: "Vorabend des Check-outs",
    whenReview: "Nach dem Check-out",
    // WhatsApp previews
    previewLead: "👋 Hallo! Ich bin der virtuelle Assistent von *{name}*.\n\nIch helfe Ihnen bei Ihrer Buchung und beantworte alle Fragen.",
    previewConfirm: "Hallo *Laura García* 👋\n\nIhre Buchung in *{name}* ist bestätigt ✅\n\nBuchungscode: *6233Q1VC5*\nDaten: *05.06.2026* – *07.06.2026* 📅\n\nÜber dieses WhatsApp können Sie Ihren Link für den Online-Check-in anfordern und auch die Anreisehinweise erhalten.\nWenn Sie vor oder während Ihres Aufenthalts Hilfe brauchen, schreiben Sie uns hier 💬",
    previewWelcome: "👋 Willkommen in *{name}*!\n\nVielen Dank für Ihre Registrierung. Hier finden Sie alle Informationen zu Ihrem Aufenthalt.",
    previewAccess: "🔒🔑 *Zugangscode · {name}*\n\nIhr Code lautet: *58117*\n\nWährend Ihres gesamten Aufenthalts gültig.",
    previewArrival: "🏡 *Anreisehinweise*\n\nGehen Sie bei Ihrer Ankunft zum Haupteingang der Unterkunft. 🔑\n\nGenießen Sie Ihren Aufenthalt! ✨",
    previewCheckout: "Hallo 👋\n\nNur zur Erinnerung: *Ihr Aufenthalt endet morgen* in *{name}*.\n\n🕚 Der späteste Check-out ist um *12:00* Uhr.\n\nGute Reise! 😊",
    previewReview: "⭐ Wie war Ihr Aufenthalt in *{name}*?\n\nWir freuen uns über Ihre Rückmeldung. Hinterlassen Sie hier Ihre Bewertung 👉 …",
    previewLeadNoWaba: "📲 *Aktivieren Sie Ihren KI-Agenten*, um neue Buchungen über WhatsApp zu bearbeiten, indem Sie Ihre eigene Nummer verbinden.\n\nSo antwortet der Assistent auch Personen, die noch keine Kunden sind, beantwortet Fragen zu Ihren Unterkünften und führt sie zur Buchung.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Wählen Sie Ihre Sprache · Choose your language",
    chatCheckinLink: "*Danke* 👋 Hier ist Ihr Link für den Check-in. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Eingang",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nIhr Zugangscode lautet: *58117*\n\nWährend Ihres gesamten Aufenthalts gültig.",
    lockNone: "🔑 *{label} · {name}*\n\nDer Schlüsselkasten öffnet sich mit dem Code: *{code}*\n\nDarin finden Sie die Schlüssel zur Unterkunft.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nDer Code für das Schloss lautet: *{code}*\n\nDamit öffnen Sie die Tür.",
    // Departure message (fallback)
    checkoutFallback: "Hallo *María* 👋\n\nNur zur Erinnerung: Ihr Aufenthalt in *{name}* endet morgen.\n\n🕚 Der späteste Check-out ist um *{time}*.\n\nVielen Dank für Ihren Aufenthalt. Gute Reise! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "iCal-Kalender",
    heading: "iCal-Synchronisierung",
    pageDesc: "Exportieren Sie Ihre Buchungen zu anderen Plattformen und importieren Sie externe Kalender, um Daten in Ihrem Inserat automatisch zu blockieren.",
    loading: "Konfiguration wird geladen…",
    exportLabel: "Ihr iCal-Link (Export)",
    exportDesc: "Kopieren Sie diesen Link und fügen Sie ihn bei Airbnb, Booking.com oder jeder Plattform mit iCal-Synchronisierung ein. Ihre Buchungen werden dort automatisch übernommen.",
    copied: "Kopiert",
    copy: "Kopieren",
    tipAllUnits: "Dieser Link enthält die Buchungen <strong>aller Einheiten</strong> des Inserats.",
    tipHotelRooms: "Jedes <strong>physische Zimmer</strong> hat seinen eigenen Link. Verbinden Sie ihn bei Airbnb/Booking für genau dieses Zimmer, dann werden nur DESSEN Buchungen exportiert.",
    importLabel: "Externe Kalender (Import)",
    syncing: "Wird synchronisiert…",
    syncAll: "Alle synchronisieren",
    importDesc: "Fügen Sie die iCal-URLs Ihrer anderen Plattformen ein (Airbnb, Booking.com usw.) und Wacheckin blockiert diese Daten automatisch in Ihrem Kalender.",
    lastSync: "Letzte Synchronisierung: {date}",
    delete: "Löschen",
    empty: "Sie haben noch keine externen Kalender verknüpft.",
    addExternal: "Externen Kalender hinzufügen",
    newExternal: "Neuer externer Kalender",
    nameLabel: "Kalendername",
    namePlaceholder: "z. B. Airbnb - Apt 1",
    physicalRoom: "Physisches Zimmer",
    listingUnit: "Einheit des Inserats",
    selectRoomPlaceholder: "Zimmer auswählen…",
    selectUnitPlaceholder: "Einheit auswählen…",
    urlLabel: "URL des iCal-Kalenders",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveSync: "Speichern und synchronisieren",
    defaultGroup: "Zimmer",
    toastLoadError: "Die iCal-Konfiguration konnte nicht geladen werden.",
    toastSelectUnit: "Wählen Sie ein Zimmer bzw. eine Einheit aus.",
    toastAdded: "Kalender erfolgreich hinzugefügt und synchronisiert.",
    toastAddError: "Fehler beim Hinzufügen des Kalenders.",
    deleteConfirm: '„{name}“ und alle damit blockierten Buchungen löschen?',
    toastDeleted: "Kalender gelöscht.",
    toastDeleteError: "Der Kalender konnte nicht gelöscht werden.",
    toastSyncError: "Fehler bei der Synchronisierung.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "iCal-Synchronisierung",
    loading: "Konfiguration wird geladen…",
    exportLabel: "Ihr iCal-Link (Export)",
    exportDesc: "Kopieren Sie diesen Link und fügen Sie ihn bei Airbnb, Booking.com oder jeder Plattform mit iCal-Synchronisierung ein. Ihre Buchungen werden dort automatisch übernommen.",
    copied: "Kopiert",
    copy: "Kopieren",
    tipAllUnits: "Dieser Link enthält die Buchungen <strong>aller Einheiten</strong> des Inserats.",
    tipHotelRooms: "Jedes <strong>physische Zimmer</strong> hat seinen eigenen Link. Verbinden Sie ihn bei Airbnb/Booking für genau dieses Zimmer, dann werden nur DESSEN Buchungen exportiert.",
    importLabel: "Externe Kalender (Import)",
    syncing: "Wird synchronisiert…",
    syncAll: "Alle synchronisieren",
    importDesc: "Fügen Sie die iCal-URLs Ihrer anderen Plattformen ein (Airbnb, Booking.com usw.) und Wacheckin blockiert diese Daten automatisch in Ihrem Kalender.",
    lastSync: "Letzte Synchronisierung: {date}",
    delete: "Löschen",
    empty: "Sie haben noch keine externen Kalender verknüpft.",
    addExternal: "Externen Kalender hinzufügen",
    newExternal: "Neuer externer Kalender",
    nameLabel: "Kalendername",
    namePlaceholder: "z. B. Airbnb - Apt 1",
    physicalRoom: "Physisches Zimmer",
    listingUnit: "Einheit des Inserats",
    selectRoomPlaceholder: "Zimmer auswählen…",
    selectUnitPlaceholder: "Einheit auswählen…",
    urlLabel: "URL des iCal-Kalenders",
    cancel: "Abbrechen",
    saveSync: "Speichern und synchronisieren",
    defaultGroup: "Zimmer",
    toastLoadError: "Die iCal-Konfiguration konnte nicht geladen werden.",
    toastSelectUnit: "Wählen Sie ein Zimmer bzw. eine Einheit aus.",
    toastAdded: "Kalender erfolgreich hinzugefügt und synchronisiert.",
    toastAddError: "Fehler beim Hinzufügen des Kalenders.",
    deleteConfirm: '„{name}“ und alle damit blockierten Buchungen löschen?',
    toastDeleted: "Kalender gelöscht.",
    toastDeleteError: "Der Kalender konnte nicht gelöscht werden.",
    toastSyncError: "Fehler bei der Synchronisierung.",
  },
};
